export default __webpack_public_path__ + "static/media/menuWorker.b9a77493.png";